import "core-js/stable";
import "regenerator-runtime/runtime";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/store";
import mitt from "mitt";
import axios from "axios";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { md3 } from "vuetify/blueprints";
import { globalCookiesConfig } from "vue3-cookies";
import VueCookies from "vue3-cookies";
import VueGtag from "vue-gtag";
import vClickOutside from "click-outside-vue3"
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';


const app = createApp(App);
const emitter = mitt();

const vuetify = createVuetify({
  components,
  directives,
  blueprint: md3,
});

app.config.globalProperties.emitter = emitter;
app.use(router);
app.use(
  VueGtag,
  {
    config: { id: "G-EBQP3H6W4F" },
  },
  router
);
app.use(store);
app.use(vuetify);
app.use(vClickOutside);

globalCookiesConfig({
  expireTimes: "7d",
  path: "/",
  domain: ".muzible.com",
  secure: true, //TODO PROD: uncomment when SSL is enabled
  sameSite: "None",
});

app.config.globalProperties.axios = axios;
app.mixin({
  created() {

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        return Promise.reject(error);
      }
    );
  },
});

app.mount("#app");
